import Heading from '@/components/ui/Heading'
import {
  ARTICLE_CARD_IMAGE_CLASS,
  ARTICLE_CARD_LINK_CLASS,
  ARTICLE_CARD_MEDIA_WRAP_CLASS,
  ARTICLE_CARD_TITLE_CLASS,
} from '@/components/ui/articleCardStyles'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

interface ArticleCardProps {
  title?: string
  date?: string
  imageUrl?: string | null
  imageAlt?: string | null
  href?: string
}

const ArticleCard = ({
  title = 'New Innovations Set to Change Many Lives Abroad',
  date,
  imageUrl,
  imageAlt,
  href = '/article/single',
}: ArticleCardProps) => {
  const formattedDate = date
    ? new Date(date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
    : null

  return (
    <Link href={href} className={ARTICLE_CARD_LINK_CLASS}>
      <div className={ARTICLE_CARD_MEDIA_WRAP_CLASS}>
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt={imageAlt ?? title}
            fill
            className={ARTICLE_CARD_IMAGE_CLASS}
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 33vw"
          />
        ) : null}
      </div>
      <Heading as="h4" className={ARTICLE_CARD_TITLE_CLASS}>
        {title}
      </Heading>
      {formattedDate && (
        <time dateTime={date} className="mt-3.25 text-xs font-kode-mono font-normal text-accent-gold block">
          {formattedDate}
        </time>
      )}
    </Link>
  )
}

export default ArticleCard
